import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiManagersMeetingNoteTemplateEditType } from "~/domains";

type ParamsType = {
  id: string;
};

const request = async ({
  id,
}: ParamsType): Promise<ApiManagersMeetingNoteTemplateEditType> => {
  const response =
    await new ApiClient().get<ApiManagersMeetingNoteTemplateEditType>(
      `/api/managers/meeting_note_templates/${id}/edit`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersMeetingNoteTemplatesEdit = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiManagersMeetingNoteTemplateEditType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersMeetingNoteTemplatesEdit", id],
    cacheTime: 0,
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
